import { Provider as IoCContainerProvider } from 'inversify-react';
import App from './App';
import Validator from './Validator';
import { iocContainer } from '@/engine/ioc';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { OfflinePage } from './engine/app/modules/offline';
import { ErrorBoundary } from './components/ErrorBoundary';

export const Root = (): JSX.Element => {
  return (
    <ErrorBoundary>
      <IoCContainerProvider container={iocContainer}>
        <BrowserRouter basename={import.meta.env.BASE_URL}>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/v3/Planner/:caseId/:packageId" element={<App />} />
            <Route path="/v3/Planner/offline" element={<OfflinePage />} />
            <Route path="/Validate/:surgeryType" element={<Validator />} />
            <Route
              path="*"
              element={
                <main style={{ padding: '1rem' }}>
                  <p>There&apos;s nothing here!</p>
                </main>
              }
            />
          </Routes>
        </BrowserRouter>
      </IoCContainerProvider>
    </ErrorBoundary>
  );
};
